<template>
  <div>
    <template>
      <v-layout wrap class="pt-4">
        <v-flex xs12 sm6 class="text-sm-left text-xs-left">
          <v-btn
            depressed
            outline
            color="primary"
            class="ma-0 mr-1 mb-1"
            @click="showSearchDialog = true"
          >
            <v-icon>search</v-icon>&nbsp;{{ $t('Advanced Search') }}
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 class="text-sm-right text-xs-right">
          <v-btn dark outline color="primary" :loading="loading" @click="handleGetTemplateImport">
            <em class="fas fa-download" />&nbsp;{{ $t('download_template_import') }}
          </v-btn>
          <importxlsx :loading="importLoading" @onChange="onImport"></importxlsx>
          <v-btn dark outline color="primary" @click="handleExportXlsx">
            <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
          </v-btn>
        </v-flex>
      </v-layout>

      <v-data-table
        :headers="headers"
        :items="branchesData"
        :loading="loading"
        hide-actions
        :pagination.sync="pagination"
        class="elevation-1 mt-4"
      >
        <!-- hide-actions -->
        <template #items="props">
          <tr>
            <td>{{ props.item.department }}</td>
            <td>{{ props.item.location }}</td>
            <td>{{ props.item.branch }}</td>
            <td>
              <v-btn
                fab
                small
                color="primary"
                outline
                class="mx-1 my-0"
                @click="handleDeleteBranch(props.item.id)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="mt-2">
        <v-pagination
          v-model="pageNumber"
          :total-visible="6"
          :length="pagelength"
          @input="handleChangePage"
        ></v-pagination>
      </div>

      <v-dialog v-model="showSearchDialog" width="500px" persistent>
        <v-card class="pa-3">
          <v-layout wrap>
            <v-flex xs6>
              <div style="display: flex; align-item: center" class="pt-3">
                <v-icon>search</v-icon> &nbsp;ค้นหา
              </div>
            </v-flex>
            <v-flex xs6 class="text-xs-right">
              <v-btn icon @click="showSearchDialog = false"><v-icon>close</v-icon></v-btn>
            </v-flex>
          </v-layout>

          <v-layout class="pa-0 ma-0" wrap row>
            <v-flex xs12 sm12 class="form-control pa-1">
              <label>เขต</label>
              <!-- <input type="text" v-model="filter.department" placeholder="เขต" /> -->
              <multiselect
                v-model="filter.department"
                :options="departmentOptions"
                :allow-empty="true"
                :searchable="true"
                select-label
                deselect-label
                :max-height="200"
                open-direction="bottom"
              ></multiselect>
            </v-flex>
            <v-flex xs12 sm12 class="form-control pa-1">
              <label>ห้าง</label>
              <!-- <input type="text" v-model="filter.location" placeholder="ห้าง" /> -->
              <multiselect
                v-model="filter.location"
                :options="locationOptions"
                :allow-empty="true"
                :searchable="true"
                select-label
                deselect-label
                :max-height="150"
                open-direction="top"
              ></multiselect>
            </v-flex>
            <v-flex xs12 sm12 class="form-control pa-1">
              <label>สาขา</label>
              <!-- <input type="text" v-model="filter.branch" placeholder="สาขา" /> -->
              <multiselect
                v-model="filter.branch"
                :options="branchOptions"
                :allow-empty="true"
                :searchable="true"
                select-label
                deselect-label
                open-direction="top"
                :max-height="200"
              ></multiselect>
            </v-flex>
          </v-layout>

          <div class="text-xs-center pt-3">
            <v-btn color="primary" depressed style="width: 150px" @click="handleSearch">{{
              $t('Search')
            }}</v-btn>
            <v-btn outline color="grey" style="width: 150px" @click="handleClearSearch">{{
              $t('Clear Search')
            }}</v-btn>
          </div>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import KingkitchenApi from '@/api/kingkitchen'
import importxlsx from '@/components/elements/importxlsx.vue'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import * as XLSX from 'xlsx'

export default {
  components: {
    Multiselect,
    importxlsx
  },
  data() {
    return {
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      headers: [
        {
          text: 'เขต',
          value: 'department',
          sortable: true
        },
        { text: 'ห้าง', value: 'location', sortable: true },
        { text: 'สาขา', value: 'branch', sortable: true },
        { text: '', value: '', sortable: false }
      ],
      filter: {
        department: '',
        location: '',
        branch: ''
      },
      branchesData: [],
      loading: false,
      showSearchDialog: false,
      importLoading: false,
      isExport: false,
      masterData: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        const total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    },
    departmentOptions() {
      let tempOptions = []
      if (this.masterData) {
        this.masterData.forEach((item) => {
          if (![...tempOptions].includes(item.department)) {
            tempOptions.push(item.department)
          }
        })
      }
      return tempOptions
    },
    locationOptions() {
      let tempOptions = []
      if (this.masterData) {
        if (this.filter.department) {
          let filteredByDepartment = this.masterData.filter((el) => {
            return el.department === this.filter.department
          })

          filteredByDepartment.forEach((item) => {
            if (![...tempOptions].includes(item.location)) {
              tempOptions.push(item.location)
            }
          })
        } else {
          this.masterData.forEach((item) => {
            if (![...tempOptions].includes(item.location)) {
              tempOptions.push(item.location)
            }
          })
        }
      }
      return tempOptions
    },
    branchOptions() {
      let tempOptions = []
      if (this.masterData) {
        if (this.filter.department) {
          let tempFilter = []
          const filteredByDepartment = this.masterData.filter((el) => {
            return el.department === this.filter.department
          })

          tempFilter = filteredByDepartment

          if (this.filter.location) {
            tempFilter = filteredByDepartment.filter((el) => {
              return el.location === this.filter.location
            })
          }

          tempFilter.forEach((item) => {
            if (![...tempOptions].includes(item.branch)) {
              tempOptions.push(item.branch)
            }
          })
        } else {
          this.masterData.forEach((item) => {
            if (![...tempOptions].includes(item.branch)) {
              tempOptions.push(item.branch)
            }
          })
        }
      }
      return tempOptions
    }
  },
  watch: {},
  mounted() {
    this.handleGetBranches()
    this.getMasterData()
  },

  methods: {
    async handleGetTemplateImport() {
      const heading = [['เขต', 'ห้าง', 'สาขา']]

      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet([])
      XLSX.utils.sheet_add_aoa(ws, heading)
      XLSX.utils.book_append_sheet(wb, ws)
      XLSX.writeFile(wb, `template-import-branch.xlsx`)
    },
    async handleExportXlsx() {
      const vm = this
      try {
        vm.isExport = true
        vm.$store.dispatch('loading')
        const response = await vm.getBranches()
        const requestData = response.data.data
        vm.isExport = false

        if (requestData == null) return
        const requests = requestData.map((el) => {
          return {
            department: el.department,
            location: el.location,
            branch: el.branch
          }
        })

        const heading = [['เขต', 'ห้าง', 'สาขา']]

        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, heading)
        XLSX.utils.sheet_add_json(ws, requests, { origin: 'A2', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws)
        XLSX.writeFile(wb, `branch-management.xlsx`)
        vm.$store.dispatch('loading')
      } catch (error) {
        vm.$store.dispatch('loading')
        console.error(error)
      }
    },
    async handleGetBranches() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await vm.getBranches()
        vm.$store.dispatch('loading')
        if (response && response.status === 200) {
          vm.branchesData = response.data.data
          vm.total = response.data.total
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        console.error(error)
      }
    },
    async getBranches() {
      const vm = this
      try {
        const limit = vm.isExport ? vm.total : vm.limit
        const offset = vm.isExport ? 0 : vm.offset
        let data = {
          page_id: vm.selectedBot.pageid,
          limit: limit,
          offset: offset,
          department: vm.filter.department,
          location: vm.filter.location,
          branch: vm.filter.branch
        }

        const response = await KingkitchenApi.getKingkitchenBranch({
          config: {
            params: data
          }
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
      }
    },
    transformHeaderField(data) {
      const result = []
      try {
        data.forEach((item) => {
          const tempItem = {
            department: '',
            location: '',
            branch: ''
          }

          Object.keys(item).forEach((element) => {
            switch (element) {
              case 'เขต':
                tempItem.department = item[element]
                break
              case 'ห้าง':
                tempItem.location = item[element]
                break
              case 'สาขา':
                tempItem.branch = item[element]
                break
              default:
              // code block
            }
          })
          result.push(tempItem)
        })
        return result
      } catch (error) {
        console.error(error)
        return result
      }
    },
    async onImport(item) {
      try {
        this.importLoading = true
        const data = {
          page_id: this.selectedBot.pageid,
          data: this.transformHeaderField(item[0])
        }
        const response = await KingkitchenApi.postKingkitchenImport({ data: data })
        this.importLoading = false
        if (response && response.status == 200) {
          await this.$swal.fire({
            text: 'สำเร็จ',
            type: 'success'
          })
          this.handleGetBranches()
        } else {
          await this.$swal.fire({
            text: 'ข้อมูลไม่ถูกต้อง'
          })
        }
      } catch (error) {
        console.error(error)
      }
    },
    handleChangePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit

        vm.handleGetBranches()
      }
    },
    handleSearch() {
      this.offset = 0
      this.pageNumber = 1
      this.handleGetBranches()
      this.showSearchDialog = false
    },
    handleClearSearch() {
      this.offset = 0
      this.pageNumber = 1
      this.filter = {
        department: '',
        location: '',
        branch: ''
      }
      this.handleGetBranches()
      this.showSearchDialog = false
    },
    async getMasterData() {
      const vm = this
      try {
        let data = {
          page_id: vm.selectedBot.pageid,
          limit: 500,
          offset: 0,
          department: '',
          location: '',
          branch: ''
        }

        const response = await KingkitchenApi.getKingkitchenBranch({
          config: {
            params: data
          }
        })

        if (response && response.status === 200) {
          vm.masterData = response.data.data
        }
      } catch (error) {
        console.error(error)
      }
    },
    async handleDeleteBranch(id) {
      const vm = this
      try {
        const result = await vm.$swal.fire({
          type: 'warning',
          text: 'คุณต้องการลบใช่หรือไม่',
          showCancelButton: true,
          cancelButtonText: vm.$t('cancel'),
          confirmButtonText: vm.$t('OK'),
          reverseButtons: true
        })

        if (result.value) {
          vm.$store.dispatch('loading')
          const response = await vm.deleteBranch(id)
          vm.$store.dispatch('loading')

          if (response && response.status === 200) {
            await this.$swal.fire({
              text: 'สำเร็จ',
              type: 'success'
            })
            vm.handleClearSearch()
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    async deleteBranch(id) {
      try {
        const response = await KingkitchenApi.deleteBranch({
          branch_id: id
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/kingKitchen/adminMenu/ManageBranches.vue